var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col p-0 m-0 hero-holder"},[_c('img',{attrs:{"src":_vm.banner.heroImage,"alt":_vm.banner.heroImageAltText,"aria-hidden":"true"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }